import React, { useContext } from 'react';
import { AuthApiReturnType } from '../api/useAuth.api';

const AuthContext = React.createContext<any>({});

type AuthProviderProps = {
  data: any;
  children: React.ReactNode;
};

export const AuthProvider: React.FC<AuthProviderProps> = ({
  data,
  children,
}) => {
  return (
    <AuthContext.Provider value={data || {}}>{children}</AuthContext.Provider>
  );
};

interface AuthContextInterface extends AuthApiReturnType {}

export const useAuthContext = () => {
  const authContextValue: AuthContextInterface = useContext(AuthContext);
  return { ...authContextValue };
};
